import React from 'react';
import { Path, Circle } from 'react-native-svg';
import useColors from 'hooks/useColors';
import { Icon } from 'design-system/icons/Icon';
const size = 20;
const IconTooltip = ({ color, colorKey, ...props }) => {
    const colors = useColors();
    const fill = color || (colorKey ? colors.elements[colorKey] : colors.text.secondary);
    return (<Icon width={props.width || size} height={props.height || size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path d="M2.23525 5.96695C2.66958 4.11534 4.11534 2.66958 5.96696 2.23525C7.30417 1.92158 8.69583 1.92158 10.033 2.23525C11.8847 2.66958 13.3304 4.11534 13.7647 5.96696C14.0784 7.30417 14.0784 8.69583 13.7647 10.033C13.3304 11.8847 11.8847 13.3304 10.033 13.7647C8.69583 14.0784 7.30417 14.0784 5.96696 13.7647C4.11534 13.3304 2.66958 11.8847 2.23525 10.033C1.92158 8.69583 1.92158 7.30417 2.23525 5.96695Z" stroke={fill}/>
      <Path d="M8 10.3327V7.66602" stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
      <Circle cx="8.00016" cy="6.00065" r="0.333333" stroke={fill} strokeWidth="0.666667" strokeLinecap="round" strokeLinejoin="round"/>
    </Icon>);
};
export default IconTooltip;
